import { LogoIcon } from './LogoIcon';

export const LogoFull = () => (
  <span className="atlas-nav__logo-full">
    <LogoIcon />
    <span className="atlas-nav__logo-name">Uzum Fintech</span>
  </span>
);
